import AlertModal from "@/components/widgets/AlertModal.vue";
import LoadingModal from "@/components/widgets/LoadingModal.vue";
import ConfirmationModal from "@/components/widgets/ConfirmationModal.vue";

/* Implement components in template

<LoadingModal v-bind="loadingModal" />
    <AlertModal
      v-bind="alertModal"
      v-model="alertModal.show"
      @dismiss="resetAlert"
    />
    <ConfirmationModal
      v-bind="confirmationModal"
      v-model="confirmationModal.show"
      @dismiss="resetConfirmation"
    />


import AlertModalMixin from "@/components/widgets/AlertModalMixin.js";

const AlertModal = AlertModalMixin.AlertModal;
const LoadingModal = AlertModalMixin.LoadingModal;
const ConfirmationModal = AlertModalMixin.ConfirmationModal;

mixins: [
    AlertModalMixin
  ],

*/

export default {
  AlertModal,
  LoadingModal,
  ConfirmationModal,
  components: {
    AlertModal,
    LoadingModal,
    ConfirmationModal
  },
  data() {
    return {
      loadingModal: {
        dialog: false,
        text: ""
      },
      alertModal: {
        show: false,
        text: "",
        type: AlertModal.INFORMATION,
        callback: null
      },
      confirmationModal: {
        show: false,
        title: "",
        text: "",
        type: ConfirmationModal.INFORMATION,
        callback: null
      }
    };
  },
  methods: {
    async alert(text, type) {
      if (!text) return Promise.resolve();
      return new Promise(resolve => {
        this.alertModal.text = text;
        if (type) this.alertModal.type = type;
        this.alertModal.callback = resolve;
        this.alertModal.show = true;
      });
    },
    resetAlert() {
      this.alertModal.text = "";
      this.alertModal.type = AlertModal.INFORMATION;
      if (!!this.alertModal.callback) {
        const callback = this.alertModal.callback;
        this.alertModal.callback = null;
        callback();
      }
    },
    startLoadingDialog(text) {
      this.loadingModal.text = text;
      this.loadingModal.dialog = true;
    },
    async stopLoadingDialog(alertText, alertType) {
      this.loadingModal.dialog = false;
      this.loadingModal.text = "";
      await this.alert(alertText, alertType);
    },
    async confirm(title, text, type) {
      if (!title) return Promise.resolve();
      return new Promise(resolve => {
        this.confirmationModal.title = title;
        if (text) this.confirmationModal.text = text;
        if (type) this.confirmationModal.type = type;
        this.confirmationModal.callback = resolve;
        this.confirmationModal.show = true;
      });
    },
    resetConfirmation(response) {
      this.confirmationModal.title = "";
      this.confirmationModal.text = "";
      this.confirmationModal.type = ConfirmationModal.INFORMATION;
      if (!!this.confirmationModal.callback) {
        const callback = this.confirmationModal.callback;
        this.confirmationModal.callback = null;
        callback(response);
      }
    }
  }
};
